import { Component, h } from "preact";
import Uploader from "../../uploader";
import {
  IEdges,
  ILabelOptionValue,
  IOption,
  IReactConfiguration,
} from "../../../typings";
import EventController from "../../../shared/controller/event-controller";
import OutputController from "../../../shared/controller/output-controller";
import TemplateController from "../../../shared/controller/template-controller";
import UnitSystemController from "../../../shared/controller/unit-system-controller";
import SizeController from "../../../shared/controller/size-controller";
import LabelSvgSprite from "../../label-uploader/label-svg-sprite";
import {
  EdgesSelectorBottomButton,
  EdgesSelectorLeftButton,
  EdgesSelectorRightButton,
  EdgesSelectorSvg,
  EdgesSelectorTopButton,
} from "../../components/EdgesSelector";

export default class LabelApplicationMethodComponent extends Component<
  ILabelApplicationMethodComponentProps,
  ILabelApplicationMethodComponentState
> {
  edgeTop: HTMLCanvasElement;
  edgeRight: HTMLCanvasElement;
  edgeBottom: HTMLCanvasElement;
  edgeLeft: HTMLCanvasElement;

  constructor(props: ILabelApplicationMethodComponentProps) {
    super(props);

    this.state = {
      sewon: props.templateController.getOptionByCode("sewon"),

      applicationMethod: null,
      sewingAllowance: null,
      edgesIncluded: false,
      edges: {},

      stateApplicationMethod: true,
      stateSewingAllowance: false,
      stateHorizontalEdges: false,
      stateVerticalEdges: false,
    };

    this.loadSaveEventListeners = this.loadSaveEventListeners.bind(this);

    this.showApplicationMethod = this.showApplicationMethod.bind(this);
    this.hideApplicationMethod = this.hideApplicationMethod.bind(this);
    this.showSewingAllowance = this.showSewingAllowance.bind(this);
    this.hideSewingAllowance = this.hideSewingAllowance.bind(this);
    this.showHorizontalEdges = this.showHorizontalEdges.bind(this);
    this.showVerticalEdges = this.showVerticalEdges.bind(this);
    this.hideHorizontalEdges = this.hideHorizontalEdges.bind(this);
    this.hideVerticalEdges = this.hideVerticalEdges.bind(this);

    this.updateOptions = this.updateOptions.bind(this);

    this.setApplicationMode = this.setApplicationMode.bind(this);
    this.setSewingAllowance = this.setSewingAllowance.bind(this);
    this.changeEdgeIncluded = this.changeEdgeIncluded.bind(this);

    this.onClickEdge = this.onClickEdge.bind(this);
    this.onHoverEdge = this.onHoverEdge.bind(this);
    this.onLeaveEdge = this.onLeaveEdge.bind(this);
  }

  componentDidMount(): void {
    const applicationMethod: string = this.props.outputController.getValue([
      "label",
      "application-method",
    ]);
    const sewingAllowance: string = this.props.outputController.getValue([
      "label",
      "edge",
    ]);
    const edgesIncluded: string = this.props.outputController.getValue([
      "label",
      "edges_includes",
    ]);
    const edges: IEdges = this.props.outputController.getValue([
      "label",
      "edges",
    ]);
    const sewonRaw: IOption =
      this.props.templateController.getOptionByCode("sewon");
    const sewon: IOption = sewonRaw
      ? this.props.outputController.getOptionFilteredValues(sewonRaw)
      : null;

    this.setState({
      sewon,
      applicationMethod,
      sewingAllowance,
      edgesIncluded: !!edgesIncluded,
      edges: edges === null ? {} : edges,
    });

    this.updateOptions();
    this.loadSaveEventListeners();

    if (applicationMethod === null) {
      this.props.outputController
        .setValue(["label", "application-method"], "sew-on")
        .then(() => {})
        .catch(() => {});
    }
  }

  loadSaveEventListeners(): void {
    let eventName: string = EventController.getSaveEventName([
      "label",
      "shape",
    ]);
    document.body
      .querySelector(this.props.conf.target)
      .addEventListener(eventName, () => {
        const shape: string = this.props.outputController.getValue([
          "label",
          "shape",
        ]);
        if (shape === "centerfold") {
          this.props.outputController
            .setValue(["label", "application-method"], "sew-on")
            .then(() => {})
            .catch(() => {});
        }
        this.updateOptions();
      });

    eventName = EventController.getSaveEventName(["label", "fold"]);
    document.body
      .querySelector(this.props.conf.target)
      .addEventListener(eventName, () => {
        this.updateOptions();
      });

    eventName = EventController.getSaveEventName([
      "label",
      "application-method",
    ]);
    document.body
      .querySelector(this.props.conf.target)
      .addEventListener(eventName, () => {
        const applicationMethod: string = this.props.outputController.getValue([
          "label",
          "application-method",
        ]);
        this.setState({
          applicationMethod,
        });
        this.updateOptions();
      });

    if (this.props.templateController.getOptionByCode("sewon")) {
      eventName = EventController.getSaveEventName(["label", "sewon"]);
      document.body
        .querySelector(this.props.conf.target)
        .addEventListener(eventName, () => {
          const applicationMethod: string =
            this.props.outputController.getValue([
              "label",
              "application-method",
            ]);
          const sewon: string = this.props.outputController.getValue([
            "label",
            "sewon",
          ]);
          if (sewon === applicationMethod) {
            return;
          }
          this.props.outputController
            .setValue(["label", "application-method"], sewon)
            .then(() => {})
            .catch(() => {});
        });
    }

    eventName = EventController.getSaveEventName(["label", "edge"]);
    document.body
      .querySelector(this.props.conf.target)
      .addEventListener(eventName, () => {
        const sewingAllowance: string = this.props.outputController.getValue([
          "label",
          "edge",
        ]);
        this.setState(
          {
            sewingAllowance,
          },
          this.updateOptions,
        );
      });

    eventName = EventController.getSaveEventName(["label", "edges_includes"]);
    document.body
      .querySelector(this.props.conf.target)
      .addEventListener(eventName, () => {
        const edgesIncluded: boolean = this.props.outputController.getValue([
          "label",
          "edges_includes",
        ]);
        this.setState(
          {
            edgesIncluded: !!edgesIncluded,
          },
          () => {
            // const sizeReferenceValue: number = this.props.outputController.getValue(
            //   ["label", "size-value"]
            // );
            // this.props.sizeController.setScale(sizeReferenceValue);
          },
        );
        this.updateOptions();
      });

    eventName = EventController.getSaveEventName(["label", "edges"]);
    document.body
      .querySelector(this.props.conf.target)
      .addEventListener(eventName, () => {
        const edges: IEdges = this.props.outputController.getValue([
          "label",
          "edges",
        ]);
        this.setState({
          edges,
        });
        this.updateOptions();
      });

    this.props.templateController
      .getOptionByCode("sewon")
      ?.values.forEach((value: ILabelOptionValue) => {
        this.loadEventListenersConditions(value.attributes?.hide?.value, () => {
          this.setState({
            sewon: this.props.outputController.getOptionFilteredValues(
              this.props.templateController.getOptionByCode("sewon"),
            ),
          });
        });
      });
  }

  private loadEventListenersConditions(
    conditions: { option: string }[],
    callable: () => void,
  ): void {
    if (!Array.isArray(conditions)) {
      return;
    }

    conditions.forEach(
      (filter: { option: string; value: { option: string }[] }) => {
        const eventName: string = EventController.getSaveEventName([
          "label",
          filter.option,
        ]);
        document.body
          .querySelector(this.props.conf.target)
          .addEventListener(eventName, callable);
        this.loadEventListenersConditions(filter.value, callable);
      },
    );
  }

  onHoverEdge(e: any): void {
    const target: HTMLCanvasElement = e.currentTarget;
    if (target.classList.contains("is-highlighted") === false) {
      target.classList.add("is-highlighted");
    }
  }

  onLeaveEdge(e: any): void {
    const target: HTMLCanvasElement = e.currentTarget;
    if (target.classList.contains("is-highlighted") === true) {
      target.classList.remove("is-highlighted");
    }
  }

  onClickEdge(value: any): void {
    const edges: { [p: string]: boolean } = { ...this.state.edges };

    const edge: string = this.props.outputController.getValue([
      "label",
      "edge",
    ]);
    const shape: string = this.props.outputController.getValue([
      "label",
      "shape",
    ]);
    if (edge === "fold" && shape === "flat" && !edges[value]) {
      if (
        (value === "top" || value === "bottom") &&
        (edges.left || edges.right)
      ) {
        return;
      }
      if (
        (value === "left" || value === "right") &&
        (edges.top || edges.bottom)
      ) {
        return;
      }
    }

    const noneSelected: boolean =
      !edges.top && !edges.right && !edges.bottom && !edges.left;
    if (noneSelected && value === "top") {
      edges.bottom = true;
    }
    if (noneSelected && value === "bottom") {
      edges.top = true;
    }
    if (noneSelected && value === "left") {
      edges.right = true;
    }
    if (noneSelected && value === "right") {
      edges.left = true;
    }

    edges[value] = !edges[value];
    this.props.outputController.startEventTransaction();

    this.props.sizeController
      .setTopEdge(edges.top)
      .then(() =>
        this.props.sizeController
          .setRightEdge(edges.right)
          .then(() =>
            this.props.sizeController
              .setBottomEdge(edges.bottom)
              .then(() =>
                this.props.sizeController
                  .setLeftEdge(edges.left)
                  .then(() => {})
                  .catch(() => {}),
              )
              .catch(() => {}),
          )
          .catch(() => {}),
      )
      .catch(() => {});
    this.props.outputController.commitEventTransaction();
  }

  async updateOptions(): void {
    const shape: string = this.props.outputController.getValue([
      "label",
      "shape",
    ]);
    const fold: string = this.props.outputController.getValue([
      "label",
      "fold",
    ]);
    const applicationMethod: string = this.props.outputController.getValue([
      "label",
      "application-method",
    ]);
    const applicationMethodValue: ILabelOptionValue =
      this.props.templateController.getOptionValue(
        this.props.templateController.getOptionByCode("sewon"),
        applicationMethod,
      );
    const sewingAllowance: string = this.props.outputController.getValue([
      "label",
      "edge",
    ]);
    const edgesIncluded: string = this.props.outputController.getValue([
      "label",
      "edges_includes",
    ]);

    if (shape === "centerfold") {
      this.hideApplicationMethod("sew-on");
      this.showSewingAllowance();

      if (
        fold === "horizontal" &&
        sewingAllowance !== "none" &&
        (!edgesIncluded || this.props.conf.setIncludedEdges)
      ) {
        this.hideHorizontalEdges();
        this.showVerticalEdges();
      } else if (
        fold === "vertical" &&
        sewingAllowance !== "none" &&
        (!edgesIncluded || this.props.conf.setIncludedEdges)
      ) {
        this.showHorizontalEdges();
        this.hideVerticalEdges();
      } else {
        this.hideHorizontalEdges();
        this.hideVerticalEdges();
      }
    }

    if (shape === "flat") {
      this.showApplicationMethod();

      if (
        applicationMethodValue !== null &&
        !applicationMethodValue?.attributes?.has_folds?.value
      ) {
        this.hideSewingAllowance(null);
        this.hideHorizontalEdges();
        this.hideVerticalEdges();
        return;
      }

      this.showSewingAllowance();
      if (
        sewingAllowance === "none" ||
        (edgesIncluded && !this.props.conf.setIncludedEdges)
      ) {
        await this.hideEdges();
      } else {
        this.showHorizontalEdges();
        this.showVerticalEdges();
      }
    }

    if (sewingAllowance === "none") {
      this.props.outputController
        .setValue(["label", "edges_includes"], false)
        .then(() => {})
        .catch(() => {});
    }

    if (shape === "custom" || shape === "miter-fold") {
      this.showApplicationMethod();
      this.hideSewingAllowance("none");
      this.hideHorizontalEdges();
      this.hideVerticalEdges();
    }
  }

  showApplicationMethod(): void {
    this.setState({
      stateApplicationMethod: true,
    });
  }

  hideApplicationMethod(applicationMethod: string): void {
    this.setState(
      {
        stateApplicationMethod: false,
      },
      () =>
        this.props.outputController
          .setValue(["label", "application-method"], applicationMethod)
          .then(() => {})
          .catch(() => {}),
    );
  }

  showSewingAllowance(): void {
    if (this.state.stateSewingAllowance) {
      return;
    }
    this.setState(
      {
        stateSewingAllowance: true,
      },
      () => {
        if (this.state.sewingAllowance) {
          return;
        }

        this.props.sizeController.setEdge("sewing-allowance");
      },
    );
  }

  hideSewingAllowance(sewingAllowance: string): void {
    this.setState(
      {
        stateSewingAllowance: false,
      },
      () => {
        if (
          this.props.outputController.getValue(["label", "edge"]) ===
          sewingAllowance
        ) {
          return;
        }
        this.props.sizeController.setEdge(sewingAllowance);
      },
    );
  }

  showHorizontalEdges(): void {
    this.setState({
      stateHorizontalEdges: true,
    });
  }

  async hideEdges(): Promise<void> {
    const edges: IEdges = this.props.outputController.getValue([
      "label",
      "edges",
    ]);

    if (edges?.left || edges?.right || edges?.top || edges?.bottom) {
      await this.props.sizeController.setLeftEdge(false);
      await this.props.sizeController.setRightEdge(false);
      await this.props.sizeController.setTopEdge(false);
      await this.props.sizeController.setBottomEdge(false);
    }

    this.setStateHideEdges();
  }

  setStateHideEdges(): void {
    this.setState({
      stateVerticalEdges: false,
      stateHorizontalEdges: false,
    });
  }

  hideHorizontalEdges(): void {
    const edges: IEdges = this.props.outputController.getValue([
      "label",
      "edges",
    ]);
    if (edges && (edges.left || edges.right)) {
      this.props.outputController.startEventTransaction();
      this.props.sizeController
        .setTopEdge(edges.top)
        .then(() => {})
        .catch(() => {});
      this.props.sizeController
        .setBottomEdge(edges.bottom)
        .then(() => {})
        .catch(() => {});
      this.props.sizeController
        .setLeftEdge(false)
        .then(() => {})
        .catch(() => {});
      this.props.sizeController
        .setRightEdge(false)
        .then(() => {})
        .catch(() => {});
      this.props.outputController.commitEventTransaction();
    }

    this.setState({
      stateHorizontalEdges: false,
    });
  }

  showVerticalEdges(): void {
    this.setState({
      stateVerticalEdges: true,
    });
  }

  hideVerticalEdges(): void {
    const edges: IEdges = this.props.outputController.getValue([
      "label",
      "edges",
    ]);
    if (edges && (edges.top || edges.bottom)) {
      this.props.outputController.startEventTransaction();
      this.props.sizeController
        .setLeftEdge(edges.left)
        .then(() => {})
        .catch(() => {});
      this.props.sizeController
        .setRightEdge(edges.right)
        .then(() => {})
        .catch(() => {});
      this.props.sizeController
        .setTopEdge(false)
        .then(() => {})
        .catch(() => {});
      this.props.sizeController
        .setBottomEdge(false)
        .then(() => {})
        .catch(() => {});
      this.props.outputController.commitEventTransaction();
    }

    this.setState({
      stateVerticalEdges: false,
    });
  }

  setApplicationMode(e: any): void {
    const target: HTMLElement = e.currentTarget;
    const value: string = target.getAttribute("data-value");

    this.props.outputController
      .setValue(["label", "application-method"], value)
      .then(() => {})
      .catch(() => {});
  }

  setSewingAllowance(e: any): void {
    const target: HTMLElement = e.currentTarget;
    const value: string = target.getAttribute("data-value");

    this.props.sizeController.setEdge(value);
  }

  async changeEdgeIncluded(): Promise<void> {
    await this.props.sizeController.setEdgesIncludes(!this.state.edgesIncluded);
  }

  private getTextForEdgeSelector(): string {
    if (
      this.state.edges.top ||
      this.state.edges.right ||
      this.state.edges.bottom ||
      this.state.edges.left
    ) {
      if (this.state.sewingAllowance === "sewing-allowance") {
        return this.props.option.meta.fields.clickMinusToRemoveSewingAllowance;
      }
      return this.props.option.meta.fields.clickMinusToRemoveAnEdge;
    }
    if (this.state.sewingAllowance === "sewing-allowance") {
      return this.props.option.meta.fields.clickAddToAddSewingAllowance;
    }
    return this.props.option.meta.fields.clickAddToAddEdges;
  }

  render(): JSX.Element {
    const sewonTemplate: IOption = this.state.sewon;

    return (
      <div>
        {this.state.stateApplicationMethod === true && sewonTemplate && (
          <div>
            {this.props.option.meta.fields.labelApplicationMethodTitle &&
              this.props.option.meta.fields
                .labelApplicationMethodDescription && (
                <div className={"mb-8"}>
                  <h5 className="mb-2 text-2xl font-bold text-black">
                    {this.props.option.meta.fields.labelApplicationMethodTitle}
                  </h5>
                  <p className="text-xl text-gray-dark">
                    {
                      this.props.option.meta.fields
                        .labelApplicationMethodDescription
                    }
                  </p>
                </div>
              )}
            <div className="flex my-8">
              {sewonTemplate.values.map(
                (value: ILabelOptionValue, index: number) => (
                  <div
                    key={index}
                    className={
                      "w-1/2 flex flex-col justify-start items-center cursor-pointer hover:bg-gray-light rounded-md p-4 " +
                      (this.state.applicationMethod === value.value
                        ? "bg-blue-lighter border-blue border border-solid"
                        : "")
                    }
                    onClick={this.setApplicationMode}
                    data-value={value.value}
                    title={value.meta.description}
                  >
                    <LabelSvgSprite
                      cssClass="h-14"
                      viewBox="0 0 64 64"
                      multicolorImage
                      conf={this.props.conf}
                      imageCode={value.value}
                    />
                    <span className="select-none">{value.meta.name}</span>
                  </div>
                ),
              )}
            </div>
          </div>
        )}

        {this.state.stateSewingAllowance === true && (
          <div>
            {this.props.option.meta.fields.labelSewingTitle &&
              this.props.option.meta.fields.labelSewingDescription && (
                <div className={"mb-8"}>
                  <h5 className="mb-2 text-2xl font-bold text-black">
                    {this.props.option.meta.fields.labelSewingTitle}
                  </h5>
                  <p className="text-xl text-gray-dark">
                    {this.props.option.meta.fields.labelSewingDescription}
                  </p>
                </div>
              )}
            <div className="flex ">
              {this.props.templateController
                .getOptionByCode("edge")
                .values.map((value: ILabelOptionValue, index: number) => (
                  <div
                    key={index}
                    className={
                      "w-1/3 flex flex-col justify-center items-center cursor-pointer hover:bg-gray-light rounded-md p-4 text-center " +
                      (this.state.sewingAllowance === value.value
                        ? "bg-blue-lighter border-blue border border-solid"
                        : "")
                    }
                    onClick={this.setSewingAllowance}
                    data-value={value.value}
                    title={value.meta.description}
                  >
                    <LabelSvgSprite
                      viewBox="0 0 64 64"
                      cssClass="h-14"
                      multicolorImage
                      conf={this.props.conf}
                      imageCode={value.value}
                    />
                    <span className="select-none">{value.meta.name}</span>
                  </div>
                ))}
            </div>
          </div>
        )}

        {this.showEdgeSelector() && (
          <div className={"mt-12"}>
            <span>
              <EdgesSelectorSvg>
                <EdgesSelectorTopButton
                  value="top"
                  disabled={!this.state.stateVerticalEdges}
                  selected={this.state.edges.top}
                  onClick={this.onClickEdge}
                />
                <EdgesSelectorRightButton
                  value="right"
                  disabled={!this.state.stateHorizontalEdges}
                  selected={this.state.edges.right}
                  onClick={this.onClickEdge}
                  extendToOuterEdge={
                    this.state.sewingAllowance === "sewing-allowance" &&
                    this.props.outputController.getValue(["label", "shape"]) ===
                      "flat"
                  }
                />
                <text
                  x="50%"
                  y="50%"
                  dominant-baseline="middle"
                  text-anchor="middle"
                  className="text-base md:text-l"
                >
                  {this.getTextForEdgeSelector()}
                </text>
                <EdgesSelectorBottomButton
                  value="bottom"
                  disabled={!this.state.stateVerticalEdges}
                  selected={this.state.edges.bottom}
                  onClick={this.onClickEdge}
                />
                <EdgesSelectorLeftButton
                  value="left"
                  disabled={!this.state.stateHorizontalEdges}
                  selected={this.state.edges.left}
                  onClick={this.onClickEdge}
                  extendToOuterEdge={
                    this.state.sewingAllowance === "sewing-allowance" &&
                    this.props.outputController.getValue(["label", "shape"]) ===
                      "flat"
                  }
                />
              </EdgesSelectorSvg>
            </span>

            <div className="flex items-center justify-center mt-8 space-x-4">
              <input
                id="checkbox"
                type="checkbox"
                className="checkbox__field "
                checked={this.state.edgesIncluded}
              />
              <label
                className="checkbox__label "
                onClick={this.changeEdgeIncluded}
              >
                {this.state.sewingAllowance === "sewing-allowance"
                  ? this.props.option.meta.fields
                      .sewingAllowanceIsAlreadyIncluded
                  : this.props.option.meta.fields.edgesAreAlreadyIncluded}
              </label>
            </div>
          </div>
        )}
      </div>
    );
  }

  private showEdgeSelector(): boolean {
    return (
      this.state.stateHorizontalEdges === true ||
      this.state.stateVerticalEdges === true ||
      (this.state.edgesIncluded && this.state.sewingAllowance !== "none")
    );
  }
}

interface ILabelApplicationMethodComponentProps {
  main: Uploader;
  conf: IReactConfiguration;
  option: IOption;

  eventController: EventController;
  outputController: OutputController;
  sizeController: SizeController;
  templateController: TemplateController;
  unitSystemController: UnitSystemController;
}

interface ILabelApplicationMethodComponentState {
  sewon: IOption;

  applicationMethod: string;
  sewingAllowance: string;
  edgesIncluded: boolean;
  edges: IEdges;

  stateApplicationMethod: boolean;
  stateSewingAllowance: boolean;
  stateHorizontalEdges: boolean;
  stateVerticalEdges: boolean;
}
